import React from "react";
import FormSteps from "../components/FormSteps";
import FormNaturalAll from "../components/FormNaturalAll";

const NaturalPersonForm = () => {
  return (
    <>
      <FormSteps />
      <FormNaturalAll />
    </>
  );
};

export default NaturalPersonForm;
